import React from 'react';
import { connect } from 'react-redux'
import VistaDeUsuario from './VistaDeUsuario';

////Importación de actions.
import {
    getData,
    setUserState,
    setMotivoBloqueo,
    resetState
} from '../actions/VistaDeUsuario';

const mapStateToProps = (state) => {
    return {
        data: state.vistaDeUsuario,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getData: (selectedUserId, currentScope) => {
            dispatch(getData(selectedUserId, currentScope));
        },
        setUserState: (id, activo, bloqueado) => {
            dispatch(setUserState(id, activo, bloqueado));
        },
        setMotivoBloqueo: (id, motivoBloqueo) => {
            dispatch(setMotivoBloqueo(id, motivoBloqueo));
        },
        resetState: () => {
            dispatch(resetState());
        }
    }
}

const VistaDeUsuarioContainer = connect(mapStateToProps, mapDispatchToProps)(VistaDeUsuario);

export default VistaDeUsuarioContainer;
